// @flow
import {
  GET_LAYOUT_STATIC_DATA_IN_PROGRESS,
  GET_LAYOUT_STATIC_DATA_SECCESS,
  GET_LAYOUT_STATIC_ERROR,
  SEND_PAYMENT_IN_PROGRESS,
  SEND_PAYMENT_RESPONSE,
  SEND_PAYMENT_ERROR,
} from '../actions/actionTypes';
import { overrideObjectWithEmptyProperty } from '../../core/ReduxUtils';

const INITIAL_STATE = {
  layoutStaticData: {},
  getStaticDataInProgress: false,
  getStaticDataSuccess: false,
  getStaticDataError: false,

  sendPaymentResponse: {},
  sendPaymentInProgress: false,
  sendPaymentSuccess: false,
  sendPaymentError: false,
};

export default function authReducer(state = INITIAL_STATE, action = {}) {
  function getLayoutStaticDataInProgress() {
    return {
      ...state,
      getStaticDataInProgress: true,
      getStaticDataSuccess: false,
      getStaticDataError: false,
    };
  }
  function getLayoutStaticDataSuccess() {
    const { logoHref, logoSrc } = action.layoutStaticData;
    let { layoutStaticData } = action;

    if (!logoHref) {
      const parceUrl = logoSrc
        .split('/')
        .map((item, index) => {
          switch (index) {
            case 0:
              return item;
            case 1:
              return '//';
            case 2:
              return item;
            default:
              return null;
          }
        })
        .join('');

      layoutStaticData = overrideObjectWithEmptyProperty({
        ...action.layoutStaticData,
        ...{ logoHref: parceUrl },
      });
    }

    return {
      ...state,
      layoutStaticData,
      getStaticDataInProgress: false,
      getStaticDataSuccess: true,
      getStaticDataError: false,
    };
  }
  function getLayoutStaticDataError() {
    return {
      ...state,
      getStaticDataInProgress: false,
      getStaticDataSuccess: false,
      getStaticDataError: true,
    };
  }
  function sendPaymentInProgress() {
    return {
      ...state,
      sendPaymentResponse: {},
      sendPaymentSuccess: false,
      sendPaymentInProgress: true,
      sendPaymentError: false,
    };
  }
  function sendPaymentResponse() {
    const { sendPaymentResponse: response, userData } = action.sendPaymentResponse;
    const sendPaymentResponse = overrideObjectWithEmptyProperty({
      ...state.sendPaymentResponse,
      ...response,
    });

    return {
      ...state,
      userData,
      sendPaymentResponse,
      sendPaymentSuccess: true,
      sendPaymentInProgress: false,
      sendPaymentError: false,
    };
  }
  function sendPaymentError() {
    const { sendPaymentResponse: response, userData } = action.sendPaymentResponse;
    const sendPaymentResponse = overrideObjectWithEmptyProperty({
      ...state.sendPaymentResponse,
      ...response,
    });

    return {
      ...state,
      userData,
      sendPaymentResponse,
      sendPaymentSuccess: false,
      sendPaymentInProgress: false,
      sendPaymentError: true,
    };
  }
  switch (action.type) {
    case GET_LAYOUT_STATIC_DATA_IN_PROGRESS:
      return getLayoutStaticDataInProgress();
    case GET_LAYOUT_STATIC_DATA_SECCESS:
      return getLayoutStaticDataSuccess();
    case GET_LAYOUT_STATIC_ERROR:
      return getLayoutStaticDataError();
    case SEND_PAYMENT_IN_PROGRESS:
      return sendPaymentInProgress();
    case SEND_PAYMENT_RESPONSE:
      return sendPaymentResponse();
    case SEND_PAYMENT_ERROR:
      return sendPaymentError();
    default:
      return state;
  }
}
